import Image from "@/components/image";
import Link from "@/components/link";
import { TextScramble } from "./text-scramble";

interface Project {
  id: number;
  title: string;
  description: string;
  image: string;
  link?: string;
}

interface ScrambledProjectGridProps {
  projects: Project[];
}

export function ScrambledProjectGrid({ projects }: ScrambledProjectGridProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mt-2 mb-2">
      {projects.map((project) => (
        <Link
          key={project.id}
          href={project.link || "#"}
          className="flex items-center gap-6 group transition-transform hover:scale-105 p-4 rounded-lg cursor-pointer"
        >
          <div className="relative w-32 h-32 flex-shrink-0 overflow-hidden rounded-md">
            <Image
              src={project.image || "/placeholder.svg"}
              alt={project.title}
              fill
              className="object-cover"
            />
          </div>
          <div className="flex-1 max-w-[250px]">
            <h3 className="text-lg leading-tight">
              <span className="font-bold text-black">
                <TextScramble
                  text={`${project.title}:`}
                  className="inline"
                  speed={30}
                  revealRate={0.055}
                />
              </span>
              <span className="text-gray-500 font-light">
                <TextScramble
                  text={` ${project.description}`}
                  className="inline"
                  speed={40}
                  revealRate={0.045}
                />
              </span>
            </h3>
          </div>
        </Link>
      ))}
    </div>
  );
}
